export const storageKeys = {
  DID_DONATE_DATE: 'didDonateDate',
  IS_BANNER_CLOSED: 'isBannerClosed',
}
